import {FC} from 'react';
import {removeFilter, useContractsTableFiltersStore} from '../../stores/contracts-table-filters.store';
import {ContractsTableFiltersList} from './contracts-table-filters-list';

interface Props {
  deletable?: boolean;
}

export const ContractsTableStoreFiltersList: FC<Props> = ({deletable}) => {
  const filters = useContractsTableFiltersStore((s) => s.filters);
  return <ContractsTableFiltersList filters={filters} {...(deletable && {onDelete: removeFilter})} />;
};
